import styled from 'styled-components';
import { playGrey10 } from '../design-tokens';
import { device } from '../breakpoints';
import { PlayLinkExternal } from '../../components/Link';
import { PlayTextStyles } from '../typography/PlayText/PlayText.styles';

export const StyledMissingContent = styled.div`
    background-color: ${playGrey10};
    padding: 32px 10px;
    margin: 40px 0;
    text-align: center;

    @media ${device.GteMedium} {
        padding: 50px;
    }
`;

export const RightsLink = styled(PlayLinkExternal)`
    ${PlayTextStyles};

    display: block;
    margin-top: 10px;

    @media ${device.GteMedium} {
        margin-top: 15px;
    }
`;
